import { Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { ReferralLayout } from './ReferralLayout';
export const Referrals: React.FC = () => {
  return <Tabs.Panel value="referrals">
      <ProfileUser />
      <ReferralLayout />
    </Tabs.Panel>;
};